import i18n from '@/i18n'
import blankLayout from '../../layout/blankLayout.vue'
import Index from './index.vue'
import SourceChannelList from './channel/list.vue'
import SourceCodeList from './sourceCode/list.vue'
import SourceChannelEditor from './channel/editor.vue'
import SourceCodeEditor from './sourceCode/editor.vue'

const basePath = '/v-admin/client-admin/source-channel/management'

export default {
  path: `${basePath}`,
  component: blankLayout,
  meta: {
    isNewPage: true,
    isAllInclude: true,
    permission: 'PERM_SOURCING_CHANNEL_MANAGEMENT',
    titleI18nKey: 'admin.customer.sourceChannelManagement.title',
    menu: {
      get label () {
        return i18n.t('admin.customer.sourceChannelManagement.menu')
      }
    }
  },
  children: [
    {
      path: `${basePath}`,
      redirect: `${basePath}/channel`,
      component: Index,
      meta: {
        permission: 'PERM_SOURCING_CHANNEL_MANAGEMENT',
        titleI18nKey: 'admin.customer.sourceChannelManagement.title'
      },
      children: [
        {
          path: `${basePath}/channel`,
          component: SourceChannelList,
          meta: {
            permission: 'PERM_SOURCING_CHANNEL_MANAGEMENT',
            titleI18nKey: 'admin.company.sourceChannelManagement.tab.channelManagement'
          }
        },
        {
          path: `${basePath}/code`,
          component: SourceCodeList,
          meta: {
            permission: 'PERM_SOURCING_CHANNEL_MANAGEMENT',
            titleI18nKey: 'admin.company.sourceChannelManagement.tab.channelManagement'
          }
        }
      ]
    },
    {
      path: `${basePath}/channel/add`,
      component: SourceChannelEditor,
      meta: {
        isEditMode: false,
        permission: 'PERM_SOURCING_CHANNEL_MANAGEMENT',
        titleI18nKey: 'admin.company.sourceChannelManagement.tab.channelAdd'
      }
    },
    {
      path: `${basePath}/code/edit/:codeId`,
      component: SourceCodeEditor,
      meta: {
        isEditMode: true,
        permission: 'PERM_SOURCING_CHANNEL_MANAGEMENT',
        titleI18nKey: 'admin.company.sourceChannelManagement.tab.sourceCodeEdit'
      }
    },
    {
      path: `${basePath}/code/add`,
      component: SourceCodeEditor,
      meta: {
        isEditMode: false,
        permission: 'PERM_SOURCING_CHANNEL_MANAGEMENT',
        titleI18nKey: 'admin.company.sourceChannelManagement.tab.sourceCodeAdd'
      }
    }
  ]
}
